import {
  type ParticuliereRelatie,
  type Relatie,
  type ZakelijkeRelatie,
  Relatietype,
} from './types';

/**
 * Bewust een functie en geen gedeelde const: aanroepers schrijven in het resultaat,
 * en bij een gedeelde const lekken die mutaties naar elk volgend formulier.
 */
function maakGedeeldeVelden() {
  return {
    automatischeIncassoAkkoord: false,
    email: '',
    rekening: undefined,
    incasso: undefined,
    telefoonnummer: '',
    adres: {
      huisnummer: undefined,
      huisnummertoevoeging: '',
      plaats: '',
      postcode: '',
      straat: '',
    },
    relatienummer: 0,
    relatieId: '',
  };
}

export function maakLegeRelatie(typeName: Relatietype = Relatietype.Z): Relatie {
  return typeName === Relatietype.P ? maakLegeParticuliereRelatie() : maakLegeZakelijkeRelatie();
}

function maakLegeZakelijkeRelatie(): ZakelijkeRelatie {
  return {
    ...maakGedeeldeVelden(),
    typeName: Relatietype.Z,
    contactpersoon: undefined,
    rechtsvorm: undefined,
    vestigingsnummer: 1,
    kvknummer: undefined,
    bedrijfsnaam: undefined,
    sbicode: '',
  };
}

function maakLegeParticuliereRelatie(): ParticuliereRelatie {
  return {
    ...maakGedeeldeVelden(),
    typeName: Relatietype.P,
    voorletters: '',
    tussenvoegsels: '',
    achternaam: '',
    geboortedatum: undefined,
    titulatuurcode: undefined,
  };
}
